import { render, staticRenderFns } from "./tnav.vue?vue&type=template&id=489dfca3&scoped=true"
import script from "./tnav.vue?vue&type=script&lang=js"
export * from "./tnav.vue?vue&type=script&lang=js"
import style0 from "./tnav.vue?vue&type=style&index=0&id=489dfca3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489dfca3",
  null
  
)

export default component.exports